import http from './http';
import { listResource } from './listResource';

export async function listUsers(options = {}) {
  return listResource('/users', options);
}

/**
 * Obtiene un usuario por su ID.
 */
export async function getUserById(id) {
  const res = await http.get(`/users/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Obtiene la lista de roles.
 */
export async function listRoles() {
  const res = await http.get('/roles');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Obtiene la lista de regiones.
 */
export async function listRegions() {
  const res = await http.get('/regions');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Crea un nuevo usuario.
 */
export async function createUser(userData) {
  const res = await http.post('/users', userData);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza un usuario.
 */
export async function updateUser(id, userData) {
  const res = await http.put(`/users/${id}`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Cambia la contraseña de un usuario.
 */
export async function changeUserPassword(userId, newPassword) {
  if (!userId) {
    throw new Error('El ID del usuario es requerido');
  }
  
  if (!newPassword) {
    throw new Error('La contraseña es requerida');
  }

  const res = await http.post(`/users/${userId}/password`, { newPassword });
  return res.data?.data ?? res.data;
}

/**
 * Sube un archivo.
 */
export async function uploadAvatar(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/users/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

/**
 * Activar/Desactivar Usuario
 */
export const updateUserStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/users/${id}/status`, { is_active: isActive });

/**
 * Eliminar Usuario
 */
export const deleteUser = (id) => http.delete(`/users/${id}`);

/**
 * Reenviar invitación de activación
 */
export const resendActivation = (id) => http.post(`/users/${id}/resend-activation`);